import { useEffect, useState } from 'react'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { NameDto } from '@model/NameDto'

import { CreateTradingAccountCampaignFormProps } from '../CreateTradingAccountCampaign.types'

export const useAccountTypesFetch = (props: CreateTradingAccountCampaignFormProps) => {
  const { values } = props
  const apiClient = useApiClient(ClientApiClient)
  const [accountTypes, setAccountTypes] = useState<NameDto<number>[]>([])

  useEffect(() => {
    const fetchAccountTypes = async () => {
      if (values.platformType?.id && values.currencyId) {
        setAccountTypes(await apiClient.getAccountType(values.platformType.id, values.currencyId))
      } else {
        setAccountTypes([])
      }
    }
    fetchAccountTypes()
  }, [values.platformType, values.currencyId, apiClient])

  return { accountTypes }
}
